import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)


import RecipeBuilder from './components/RecipeBuilder.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: '/uppskriftir/',
  routes: [
    {path: '/', component: RecipeBuilder },
    {path: '/u/:id', component: RecipeBuilder, name:'recipe' }
  ]
})

Vue.config.productionTip = false


// Simplest of states. 
var store = {
  state: { 
    recipe: [],
    recipeName: '',
    recipeText: '',
    products: [],
    categories: []
  }
}

new Vue({
  router: router,
  render: h => h(App),
  data: {
    state: store.state
  }

}).$mount('#app')
